import React from 'react';
import { useMutation, useQuery } from 'react-apollo';
import { MenuForPos, UpdateMenuItemSoldoutYn } from 'graphql/menu';

export default function MenuPanel({ shopId, onClose }) {
  const { data, loading, refetch } = useQuery(MenuForPos, {
    fetchPolicy: 'no-cache',
    variables: { shopId },
    skip: !shopId,
  });
  const [updateSoldout] = useMutation(UpdateMenuItemSoldoutYn);

  const menuGroups = data?.menu?.menuGroups || [];
  const menuItems = menuGroups.reduce((items, group) => items.concat(group.menuItems || []), []);

  const changeSoldout = async (menuItem, soldoutYn) => {
    try {
      await updateSoldout({
        variables: {
          menuItemId: menuItem.menuItemId,
          soldoutYn,
        },
      });
      await refetch();
    } catch (error) {
      console.error(error);
    }
  }; 

  return (
    <aside className="w-full md:w-96 h-full md:border-l border-cust-line bg-white flex flex-col shadow-lg">
      <div className="flex items-center justify-between h-14 px-4 border-b border-cust-line shrink-0">
        <h2 className="text-lg font-bold text-gray-900">메뉴 판매 관리</h2>
        <button className="w-9 h-9 text-2xl leading-none text-gray-600 hover:text-black" onClick={onClose} aria-label="메뉴 관리 닫기">
          &times;
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-3">
        {loading && <p className="py-8 text-center text-gray-500">메뉴를 불러오는 중입니다.</p>}
        {!loading && menuItems.length === 0 && <p className="py-8 text-center text-gray-500">등록된 메뉴가 없습니다.</p>}
        {!loading && menuGroups.map((group) => (
          <section key={group.menuGrpId} className="mb-5">
            <h3 className="mb-2 text-sm font-bold text-gray-700">{group.menuGrpNm}</h3>
            <div className="space-y-2">
              {(group.menuItems || []).map((menuItem) => (
                <div key={menuItem.menuItemId} className="flex items-center gap-3 p-2 border border-gray-200 rounded bg-gray-50">
                  {menuItem.menuItemThumbImgUrl || menuItem.menuItemSquareImgUrl ? (
                    <img
                      className="w-16 h-16 object-cover rounded bg-gray-200 shrink-0"
                      src={menuItem.menuItemThumbImgUrl || menuItem.menuItemSquareImgUrl}
                      alt=""
                    />
                  ) : (
                    <div className="w-16 h-16 rounded bg-gray-200 shrink-0" />
                  )}
                  <span className="flex-1 min-w-0 text-sm font-semibold text-gray-900 truncate">{menuItem.menuItemNm}</span>
                  <div className="flex shrink-0 gap-1">
                    <button
                      className={`px-2 py-2 text-xs font-bold rounded transition-all cursor-pointer ${
                        menuItem.soldoutYn
                          ? 'bg-gray-200 text-gray-400'
                          : 'bg-primary text-white ring-2 ring-primary ring-offset-1 shadow-md hover:opacity-90'
                      }`}
                      onClick={() => changeSoldout(menuItem, false)}
                      disabled={!menuItem.soldoutYn}
                    >
                      판매중
                    </button>
                    <button
                      className={`px-2 py-2 text-xs font-bold rounded transition-all cursor-pointer ${
                        menuItem.soldoutYn
                          ? 'bg-alert text-white ring-2 ring-alert ring-offset-1 shadow-md hover:opacity-90'
                          : 'bg-gray-200 text-gray-400'
                      }`}
                      onClick={() => changeSoldout(menuItem, true)}
                      disabled={menuItem.soldoutYn}
                    >
                      판매 중지
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </aside>
  );
}
